import { render, staticRenderFns } from "./UpdateMusic.vue?vue&type=template&id=01f1e980&scoped=true&"
import script from "./UpdateMusic.vue?vue&type=script&lang=js&"
export * from "./UpdateMusic.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMusic.vue?vue&type=style&index=0&id=01f1e980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f1e980",
  null
  
)

export default component.exports